"use client"
import { Box, Button, Typography, Stack } from '@mui/material'
import React from 'react'
import CloseIcon from '@mui/icons-material/Close';
import { deleteUserType } from './userType.service';
import { resultMessage } from '../../../../service/apiResult';
import { Icon } from "@iconify/react";
import {
    confirmationDialogSx,
    confirmationIconSx,
    confirmationPrimaryButtonSx,
    confirmationSecondaryButtonSx,
    confirmationTextSx,
    confirmationTitleSx,
} from '../../../styles/dialogStyles';

export default function DeleteModal(props) {

    const { onClose, getUserTypeData, selectedId, setResponseMsg, setAlert, setOpenAlert, setLoading, ALERT_DURATION, alertClose, setActionError } = props;

    const onSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const res = await deleteUserType(selectedId);
        setLoading(false);

        if (!res.success) {
            // The server refuses this when users are still assigned to the persona, and says how
            // many. That is an instruction to go and reassign them, not a passing notification, so
            // it goes to the banner above the table and stays until dismissed. Nothing is
            // refreshed — nothing changed.
            setActionError(resultMessage(res));
            onClose();
            return;
        }

        setActionError('');
        // The endpoint returns the updated persona, not a message, so the wording is ours.
        setResponseMsg(resultMessage(res, 'User persona deleted successfully'));
        setAlert('true');
        setOpenAlert(true);
        setTimeout(() => {
            alertClose();
            getUserTypeData();
            onClose();
        }, ALERT_DURATION);
    };


    return (
        <Box sx={confirmationDialogSx}>
            <Stack direction="row" justifyContent="flex-end" sx={{ mb: 1 }}>
                <Button onClick={onClose} sx={{ minWidth: 'auto', p: 0.5, color: '#6B7280', borderRadius: '999px' }}>
                    <CloseIcon />
                </Button>
            </Stack>
            <form onSubmit={onSubmit}>
                <Stack spacing={2} alignItems="center" textAlign="center">
                    <Box sx={confirmationIconSx}>
                        <Icon icon="proicons:alert-triangle" width="36" height="36" color="#C40000" />
                    </Box>
                    <Typography sx={confirmationTitleSx}>Warning!</Typography>
                    <Typography sx={confirmationTextSx}>Do you want to continue?</Typography>
                    <Typography sx={confirmationTextSx}>This action cannot be undone.</Typography>
                    <Stack direction="row" spacing={1.5} justifyContent="center" sx={{ pt: 1 }}>
                        <Button variant="contained" type="submit" sx={confirmationPrimaryButtonSx}>Yes</Button>
                        <Button onClick={onClose} sx={confirmationSecondaryButtonSx}>No</Button>
                    </Stack>
                </Stack>
            </form>
        </Box>
    )
}
